import React from 'react';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import InstanceForm from '../Shared/InstanceForm';
import {instanceDocumentTitle} from '../instanceHelpers';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const CreateInstancePage: React.FC = () => {
  useSetDocumentTitle(instanceDocumentTitle);

  return (
    <ContentWrapper>
      <InstanceForm id={undefined} mode="create" />
    </ContentWrapper>
  );
};

export default CreateInstancePage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.InstancesCreate(),
  element: <CreateInstancePage />,
  isPrivate: true,
  requireSuperAdmin: true,
});
